var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.99999,
    height: 40,
    viewBox: "0 0 34.99999 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "M2.4992,36.2496c0,2.07129,1.67911,3.7504,3.7504,3.7504H28.75039c2.07129,0,3.7504-1.67911,3.7504-3.7504V10.00001H2.4992v26.24959ZM23.74879,16.24961c0-.69058,.55982-1.2504,1.2504-1.2504s1.2504,.55982,1.2504,1.2504v17.50079c0,.69013-.55947,1.2496-1.2496,1.2496s-1.2496-.55947-1.2496-1.2496h0l-.0016-17.50079Zm-7.4992,0c0-.69013,.55946-1.2496,1.2496-1.2496s1.2496,.55946,1.2496,1.2496v17.50079c0,.69013-.55946,1.2496-1.2496,1.2496s-1.2496-.55947-1.2496-1.2496h0V16.24961Zm-7.4992,0c0-.69058,.55982-1.2504,1.2504-1.2504s1.2504,.55982,1.2504,1.2504v17.50079c0,.69013-.55946,1.2496-1.2496,1.2496s-1.2496-.55947-1.2496-1.2496h0l-.0016-17.50079ZM33.75039,2.50082h-9.376l-.7344-1.4624C23.32267,.40205,22.67269-.00008,21.96159,.00002H13.032c-.7103-.00298-1.35979,.40038-1.672,1.0384l-.7344,1.4608H1.2496C.55947,2.49921,0,3.05868,0,3.74881c0,.00053,0,.00107,0,.0016v2.4992c0,.69013,.55946,1.2496,1.2496,1.2496H33.75039c.69013,0,1.2496-.55946,1.2496-1.2496h0V3.75042c0-.69013-.55946-1.2496-1.2496-1.2496h0Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.0dc1aae7b7d98d962ae455a9c3c4e344.svg";
export { ForwardRef as ReactComponent };